import React from 'react'
import { Sidebar, Text, Heading } from '../../components/ui'
import { PermissionGuard } from '../../components/PermissionGuard'

const CRMRelatorios: React.FC = () => {
  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-x-hidden overflow-y-auto">
        <PermissionGuard moduleName="crm_relatorios" permissionType="show">
          <div className="py-6 px-4 sm:px-6 lg:px-8">
            <div className="mb-6">
              <Heading as="h1" size="3xl" className="text-gray-900 dark:text-white">Relatórios</Heading>
              <Text size="sm" color="muted" className="mt-2">Indicadores de vendas e produtividade</Text>
            </div>
            <Text size="sm" color="muted">Relatórios — em construção.</Text>
          </div>
        </PermissionGuard>
      </div>
    </div>
  )
}

export default CRMRelatorios
